const users = (state) => state.users;
const hasUsers = (state) => state.users.length > 0;
const getUserById = (state) => (id) => state.usersCache.find((user) => user.id === id);
const getUsersByIds = (state) => (ids) => state.usersCache.filter((user) => ids.includes(user.id));

const hasUserById = (state) => (id) => typeof state.usersCache.find((user) => user.id === id) !== "undefined";

export default {
  users,
  hasUsers,
  getUserById,
  hasUserById,
  getUsersByIds,
};
